<template>
  <div id="app" v-cloak>
    <transition :name="transitionName">
      <router-view class="child-view"></router-view>
    </transition>
  </div>
</template>

<script>
export default {
  name: "App",
  data() {
    return {
      // screenWidth: JSON.parse(localStorage.getItem("screenWidth")), //本地缓存
      screenWidth: window.screen.width, // 屏幕尺寸
      transitionName: "",
      // screenWidth:document.body.clientWidth,
      clientHeight: document.body.clientHeight,
    };
  },
  mounted() {
    const that = this;

    if (this.screenWidth == 1920) {
      document.querySelector("body").setAttribute("style", "zoom:1");
    }

    if (this.screenWidth == 1366) {
      document.querySelector("body").setAttribute("style", "zoom:0.75");
    }

    if (this.screenWidth == 1242) {
      document.querySelector("body").setAttribute("style", "zoom:0.75");
    }

    if (this.screenWidth == 1518) {
      document.querySelector("body").setAttribute("style", "zoom:0.75");
    }

    if (this.screenWidth == 1360) {
      document.querySelector("body").setAttribute("style", "zoom:0.75");
    }
  },
  methods: {},
  watch: {
    //使用watch 监听$router的变化

    $route(to, from) {
      //如果to索引大于from索引,判断为前进状态,反之则为后退状态
      if (to.meta.index > from.meta.index) {
        //设置动画名称
        this.transitionName = "slide-left";
      } else {
        this.transitionName = "slide-right";
      }
    },
  },
};
</script>

<style>
.el-table__header tr,
.el-table__header th {
  padding: 0;
  height: 40px;
  color: #000;
}

.el-menu.el-menu--horizontal {
  /* border-bottom: none; */
  border-bottom: 1px #ffffff !important;
}

.el-drawer:focus {
  outline: none !important;
}

.el-drawer__container {
  margin-left: 4.5%;
  outline: none !important;
}

.switchStyle .el-switch__label {
  position: absolute;
  display: none;
  color: #fff;
}
.switchStyle .el-switch__label--left {
  z-index: 9;
  left: 6px;
}
.switchStyle .el-switch__label--right {
  z-index: 9;
  left: -14px;
}
.switchStyle .el-switch__label.is-active {
  display: block;
}
.switchStyle.el-switch .el-switch__core,
.el-switch .el-switch__label {
  width: 50px !important;
}

.el-tabs--border-card > .el-tabs__header .el-tabs__item {
  font-weight: 600;
  color: #2d2e2f;
  font-size: 15px;
}

/*  谷歌浏览器滚动条样式
------------------------------------------------ */
::-webkit-scrollbar {
  width: 10px;
  height: 10px;
}

/*定义滚动条轨道 内阴影+圆角*/
::-webkit-scrollbar-track {
  border-radius: 10px;
  background-color: rgba(0, 0, 0, 0.1);
}

/*定义滑块 内阴影+圆角*/
::-webkit-scrollbar-thumb {
  border-radius: 10px;
  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
  background-color: rgba(0, 0, 0, 0.1);
}

/*  火狐浏览器滚动条设置
------------------------------------------------ */
@-moz-document  {
  scrollbar-color: #c7c7c7 #e5e5e5;
  scrollbar-width: thin;
}

.el-tag + .el-tag {
  margin-left: 20px;
}
.button-new-tag {
  margin-left: 20px;
  height: 32px;
  line-height: 30px;
  padding-top: 0;
  padding-bottom: 0;
}

.v2 >>> .el-select-dropdown {
  margin-top: 12px;
  z-index: 2 !important;
}

.el-checkbox__inner {
  width: 17px;
  height: 17px;
}

.el-checkbox__inner::after {
  height: 9px;
  width: 3px;
  left: 6px;
}

.el-button--small,
.el-button--small.is-round {
  /* box-shadow: 0 1px 12px 0 rgba(0, 0, 1, 0.3); */
  box-shadow: 0 1px 6px rgba(0, 0, 0, 0.117647),
    0 1px 6px rgba(0, 0, 0, 0.117647);
}

.el-table-column--selection .cell {
  text-align: center;
}

.el-table th > .cell {
  font-size: 15px;
  color: #5b5b5b;
}

.el-popover__title {
  color: #d6102e;
}

.el-radio__inner {
  width: 17px;
  height: 17px;
}

.el-radio__inner::after {
  width: 6px;
  height: 6px;
}

.el-button--info.is-plain {
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.1), 0 1px 4px rgba(0, 0, 0, 0.1);
}

.el-button--primary.is-plain {
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.1), 0 1px 4px rgba(0, 0, 0, 0.1);
}

.el-button--danger.is-plain {
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.1), 0 1px 4px rgba(0, 0, 0, 0.1);
}

.el-input__inner {
  box-shadow: 0 1px 10px 0 rgba(0, 0, 0, 0.05);
}

.el-button--mini {
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.1), 0 1px 4px rgba(0, 0, 0, 0.1);
}

.el-submenu__icon-arrow {
  display: none !important;
}
.is-top {
  font-size: 1rem;
  border-radius: 0.3rem;
}

.el-menu--popup {
  /* box-shadow: 0 2px 12px 0 rgba(0,0,0,.3);
  z-index: 200000; */
  /* box-shadow:0; */
  box-shadow: none !important;
}

.el-menu--horizontal .el-menu .el-menu-item {
  text-align: center;
  color: rgb(15 15 15) !important;
}

.el-menu--collapse .el-menu .el-submenu,
.el-menu--popup {
  min-width: 152px !important;
}

.el-menu--popup-bottom-start {
  margin-top: 0px !important;
}
.el-menu--horizontal .el-menu .el-menu-item,
.el-menu--horizontal .el-menu .el-submenu__title {
  color: rgb(39, 39, 39);
}
.el-tooltip__popper.is-dark {
  margin-left: 18px;
}
.child-view {
  transition: all 0.3s;
  /* display:flex */
}
.slide-left-enter,
.slide-right-leave-active {
  opacity: 0;
  transform: translate(10%, 0);
}
.slide-left-leave-active,
.slide-right-enter {
  opacity: 0;
  transform: translate(-10%, 0);
}
* {
  margin: 0;
  padding: 0;
  outline: none !important;
}
#app {
  height: 100%;
}

/* 字体尺寸适配屏幕分辨率 */
.mdFont {
  font-size: 16px;
}

.smFont {
  font-size: 14px;
}

.el-input.is-disabled .el-input__inner {
  background-color: #e5e5e9 !important;
  border-color: #a9a9aa !important;
  cursor: not-allowed !important;
}

.el-input .el-input__inner {
  border-color: #a9a9aa !important;
  color: rgb(40, 40, 40) !important;
}

.el-textarea .el-textarea__inner {
  border-color: #a9a9aa !important;
  color: rgb(40, 40, 40) !important;
}

.el-textarea.is-disabled .el-textarea__inner {
  background-color: #e5e5e9 !important;
  border-color: #a9a9aa !important;
  cursor: not-allowed !important;
}

.el-date-editor {
  border-color: #a9a9aa !important;
  color: rgb(40, 40, 40) !important;
}
.el-input ::-webkit-input-placeholder {
  color: #838282 !important;
}
.el-input :-moz-placeholder {
  color: #838282 !important;
}
.el-input ::-moz-placeholder {
  color: #838282 !important;
}
.el-input :-ms-input-placeholder {
  color: #838282 !important;
}

.el-date-editor ::-webkit-input-placeholder {
  color: #838282 !important;
}
.el-date-editor :-moz-placeholder {
  color: #838282 !important;
}
.el-date-editor ::-moz-placeholder {
  color: #838282 !important;
}
.el-date-editor :-ms-input-placeholder {
  color: #838282 !important;
}

.el-textarea ::-webkit-input-placeholder {
  color: #838282 !important;
}
.el-textarea :-moz-placeholder {
  color: #838282 !important;
}
.el-textarea ::-moz-placeholder {
  color: #838282 !important;
}
.el-textarea :-ms-input-placeholder {
  color: #838282 !important;
}

/* 角标刷新提示 */
.el-tooltip__popper.is-dark.tooltip {
  margin-left: 6px !important;
  background-color: rgba(120, 120, 120, 0.9) !important;
  border: 1px solid rgb(120, 120, 120) !important;
  border-radius: 6px !important;
}

.tooltip.el-tooltip__popper .el-button{
  padding: 0px !important;
  width: 60px !important;
  height: 30px !important;
  text-align: center !important;
}

.tooltip.el-tooltip__popper[x-placement^="right"] .popper__arrow {
  border-right-color: rgb(120, 120, 120) !important ;
  top: 28px !important;
}
.tooltip.el-tooltip__popper[x-placement^="right"] .popper__arrow::after {
  border-right-color: rgb(120, 120, 120) !important;
}

/* 查询栏公用样式 */
.searchBoxGlobal .el-row {
  margin-bottom: 20px;
  height: 32px;
}

.searchBoxGlobal .el-col {
  display: flex;
  justify-content: left;
  padding-left: 30px;
}

.searchBoxGlobal .el-col>span {
  width: 100px;
  white-space: nowrap;
  line-height: 32px;
}

.searchBoxGlobal .el-col>.shortSpan {
  width: 80px;
}

.searchBoxGlobal .el-col>span + * {
  width: 100%;
}

.searchBoxGlobal .el-button{
  margin-right: 15px;
}

.searchBoxGlobal .el-col .el-radio {
  line-height: 32px;
}

.el-input .el-input__inner[readonly] {
  cursor: pointer !important;
  background: #e5e5e9 !important;
}
.el-select .el-input__inner[readonly] {
  background: #fff !important;
}
</style>



// WEBPACK FOOTER //
// src/App.vue